import { Controller } from 'stimulus'
import Rails from "@rails/ujs";

export default class extends Controller {
  checkboxSubmit() {
    Rails.fire(this.element, 'submit');
  }
}